module.exports = __webpack_public_path__ + "img/overhangs.938cd825.png";